import denormalize from 'helpers/denormalizer';
import { deepMergeWithArrayReplacement } from 'helpers/transform';

export const getMergedPartnershipData = (partnershipData, partnershipId, parsedResponse) => {
  const selectedPartnership = parsedResponse.partnership[partnershipId];

  return deepMergeWithArrayReplacement(partnershipData, denormalize(parsedResponse, selectedPartnership));
};
